import axios from 'axios';
import { ADMIN_API_ORIGIN } from '@/config/domains';
import { API_TIMEOUT } from '@/utils/constants';

export const DESKTOP_API_BASE_URL = `${ADMIN_API_ORIGIN}/api/desktop/`;

const desktopApi = axios.create({
  baseURL: DESKTOP_API_BASE_URL,
  timeout: API_TIMEOUT,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

desktopApi.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    if (error.response) {
      const { status, data } = error.response;
      console.error(`Desktop API Error: ${status}`, data);

      if (status === 401) {
        import('@/stores/authStore').then(({ authStore }) => {
          authStore.setUser(null);
        });
      }
    } else if (error.request) {
      console.error('Desktop API Network Error', error.request);
    } else {
      console.error('Desktop API Error', error.message);
    }

    return Promise.reject(error);
  },
);

export default desktopApi;
